/*
 * ============================================================================
 * TableFilterSelect — filtre Select standard des tables
 * ----------------------------------------------------------------------------
 * POSITIONNEMENT DANS UNE TABLE :
 *   Se place dans la barre d'outils du conteneur Paper de la table
 *   (MuiPaper-elevation2), cote GAUCHE. Les filtres sont empiles
 *   verticalement (Stack direction="column") quand il y en a plusieurs.
 *
 * DESIGN UI :
 *   - Select blanc borde de var(--primaryColor) (meme bleu que l'en-tete
 *     des tables), coins a 6px
 *   - La fleche du Select repose sur un bloc bleu var(--primaryColor)
 *     a droite du champ, icone blanche — meme langage visuel que
 *     TableSearchInput variante blueIcon
 *   - size="small" dans les tables (meme hauteur que la recherche)
 *
 * USAGE :
 *   <TableFilterSelect
 *       value={statutFilter}
 *       onChange={(v) => { setStatutFilter(v); setPage(1); }}
 *       options={[{ value: 'TOUS', label: 'Tous les statuts' }, ...]}
 *   />
 * ============================================================================
 */
import React from 'react';
import { Select } from 'antd';
import { Box } from '@mui/material';

// Meme bleu que l'en-tete des tables antd (var(--primaryColor))
const CSAL_BLUE = 'var(--primaryColor, #116599)';

export interface TableFilterSelectProps {
    value: string;
    onChange: (value: string) => void;
    options: { value: string; label: string }[];
    icon?: React.ReactNode;
    width?: number;
    size?: 'small' | 'middle' | 'large';
}

const TableFilterSelect: React.FC<TableFilterSelectProps> = ({
    value,
    onChange,
    options,
    icon,
    width = 170,
    size = 'small'
}) => (
    <Box sx={{
        display: 'inline-flex',
        width,
        '& .ant-select': { width: '100%' },
        '& .ant-select-selector': {
            border: `1px solid ${CSAL_BLUE} !important`,
            borderRadius: '6px !important',
            paddingRight: '38px !important'
        },
        '& .ant-select:hover .ant-select-selector, & .ant-select-focused .ant-select-selector': {
            borderColor: `${CSAL_BLUE} !important`
        },
        // Fleche du select sur fond bleu plein hauteur, icone blanche
        '& .ant-select-arrow': {
            top: 0,
            right: 0,
            insetInlineEnd: '0 !important',
            bottom: 0,
            marginTop: '0 !important',
            width: 30,
            height: '100%',
            transform: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: CSAL_BLUE,
            color: '#fff',
            borderTopRightRadius: '5px',
            borderBottomRightRadius: '5px'
        },
        '& .ant-select-arrow svg': { fill: '#fff' }
    }}>
        <Select
            size={size}
            value={value}
            onChange={(v) => onChange(v as string)}
            options={options}
            suffixIcon={icon}
            style={{ width: '100%' }}
        />
    </Box>
);

export default TableFilterSelect;
